var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCraftFullBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 127.841 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Craft-logo-white",
    transform: "translate(-38.118 -128.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    d: "M105.926,140.417a7.655,7.655,0,0,1-5.616,2.434,5.566,5.566,0,0,1-5.8-5.678c0-3.557,2.371-6.115,5.678-6.115a7.58,7.58,0,0,1,5.491,2.434l.25.25,1.622-1.685-.25-.25A9.689,9.689,0,0,0,100.185,129c-5.117,0-8.985,3.494-8.985,8.174,0,4.43,3.806,7.8,8.8,7.8a10.551,10.551,0,0,0,7.425-2.87l.25-.25-1.56-1.622Z",
    transform: "translate(-19.961 -0.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    d: "M140.516,137a3.994,3.994,0,0,0,.187-5.741c-1.248-1.248-2.5-1.56-5.491-1.56H127.1v15.1h3v-6.24h4.929l3.806,6.24h3.494l-4.118-6.552A4.939,4.939,0,0,0,140.516,137Zm-1.747-2.808c0,1.435-1.061,2.246-2.87,2.246h-5.8v-4.617h5.491c2.184,0,3.182.686,3.182,2.371Z",
    transform: "translate(-33.46 -0.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    d: "M165.563,129.6,158.2,144.7h2.683l1.747-3.869h7.737l1.872,3.869h3.369l-7.238-15.1Zm3.806,9.235H163.5l2.87-6.24Z",
    transform: "translate(-45.154 -0.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    d: "M193.5,144.7h3v-6.3h5.865v-2.184H196.5v-4.368h9.672V129.6H193.5Z",
    transform: "translate(-58.428 -0.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    d: "M221.6,129.6v2.246h5.179V144.7h3V131.846h5.179V129.6Z",
    transform: "translate(-68.994 -0.241)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    transform: "translate(60.271 144.87) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    d: "M11.045,0,0,4.056V6.3L11.045,2.246Z",
    transform: "translate(11.107 9.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    d: "M22.089,0,11.044,4.056,0,8.112v2.246L11.044,6.3,22.089,2.246Z",
    transform: "translate(0.063 5.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    d: "M22.089,2.246V0L11.044,4.056,0,8.112v2.246L11.044,6.3Z",
    transform: "translate(0.063 0.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    d: "M11.045,0,0,4.056V6.3L11.045,2.246Z",
    transform: "translate(0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraftFullBlack);
export default __webpack_public_path__ + "static/media/craft-full-black.a66de135b4f557459678ee3473f00f17.svg";
export { ForwardRef as ReactComponent };